import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Params, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth.service';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const redirectIfAuthenticatedGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = await authService.getCurrentUser();

  if (!user) {
    return true;
  }

  const { ref } = route.queryParams;
  const forwardedParams: Params = { ref };

  return router.createUrlTree([user.redirectUrlAfterLogin], {
    queryParams: forwardedParams,
    queryParamsHandling: 'merge',
  });
};
